import { useMemo } from 'react'

import { useFetchTopCoinList } from '@/hooks/use-nemo-apis'
import { toRegistryTokenInfo } from '@/utils/apis/helper'

export const BLACK_LIST_TOKENS_SYMBOLS = ['reSOL', 'reBNB']

/**
 * These token options will be used in the deposit and withdraw dialog in the assets page
 */
const useDepositTokenOptions = () => {
  const { data: coreTokens = [], isLoading: isFetchingCoreTokens } = useFetchTopCoinList()

  const tokenOptions = useMemo(
    () =>
      coreTokens
        .filter((token) => !BLACK_LIST_TOKENS_SYMBOLS.includes(token.token_symbol))
        .map((token) => toRegistryTokenInfo(token)),
    [coreTokens],
  )

  return { tokenOptions, isLoading: isFetchingCoreTokens }
}

export default useDepositTokenOptions
